export default __webpack_public_path__ + "static/media/img3.9384c95c.jpg";